// extracted by mini-css-extract-plugin
export default {"LoaderTitle":"LoaderTitle---IMng5","AccordionHeaderLoading":"AccordionHeaderLoading---HN8tb"};